import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
	  path: '/index',
	  name: 'index',
	  component: () => import('@/views/Index.vue'),
		redirect:'/home',
		children:[
			{
				path: '/home',
				name: 'home',
				component: () => import('@/views/Home.vue'),
			},
			{
				path: '/list',
				name: 'list',
				component: () => import('@/views/List.vue'),
			},
			{
				path: '/intro',
				name: 'intro',
				component: () => import('@/views/Intro.vue'),
			},
			{
				path: '/apply',
				name: 'apply',
				component: () => import('@/views/Apply.vue'),
			},
			{
				path: '/branch',
				name: 'branch',
				component: () => import('@/views/Branch.vue'),
			},
			{
				path: '/search',
				name: 'search',
				component: () => import('@/views/Search.vue'),
			},
			{
				path: '/detail',
				name: 'detail',
				component: () => import('@/views/Detail.vue'),
			},
		]
	},
	{
	  path: '/*',
	  redirect: '/index'
	},
]

const router = new VueRouter({
	// mode: 'history',
  routes
})

export default router
